import { authorizedInstance } from "../config/axios"

export const getGeneralIssuerSettings = async () => {
  const response = await authorizedInstance.get("/general-issuer-settings")
  return response.data
}

export const updateGeneralIssuerSettings = async (data) => {
  const response = await authorizedInstance.put(
    "/general-issuer-settings",
    data
  )
  return response.data
}
